export default __webpack_public_path__ + "static/media/linkedin.c40c17f2.svg";